<template>
  <div>
    <b-modal
      size="md"
      id="modalDados"
      header-text-variant="light"
      centered
      no-close-on-backdrop
      hide-footer
      hide-header
    >
      <div class="container">
        <h4 class="c-orange text-center">
          Favor inserir os dados de quem está solicitando
        </h4>

        <div class="mt-4">
          <label>Nome do solicitante</label>
          <input
            type="text"
            class="form-control cursor-pointer"
            v-model="fields.name"
            placeholder="Insira o nome do solicitante"
          />
        </div>

        <div class="mt-2">
          <label>Telefone solicitante</label>
          <input
            type="text"
            v-mask="['(##) #####-####', '(##) ####-####']"
            class="form-control cursor-pointer"
            v-model="fields.phone"
            placeholder="Insira o telefone do solicitante"
          />
        </div>

        <div class="mt-4 text-right">
          <!-- <b-button class="mr-2" variant="danger" @click="close()">
            <i class="fas fa-times mr-2"></i>
            Fechar
          </b-button> -->
          <b-button variant="success" @click="verifyData()"> Próximo </b-button>
        </div>
      </div>
    </b-modal>

    <ShopkeeperAppContract>
      <template #actions>
        <div class="text-right">
          <b-button
            class="mt-3 mr-2"
            variant="danger"
            @click="$bvModal.hide('shopkeeper-app-contract')"
          >
            <i class="fas fa-times mr-2"></i>
            Fechar Contrato
          </b-button>
          <b-button class="mt-3" variant="success" @click="send()">
            <i class="fas fa-check mr-2"></i>
            Aceitar
          </b-button>
        </div>
      </template>
    </ShopkeeperAppContract>
  </div>
</template>

<script>
import ShopkeeperAppContract from 'Components/Contract/ShopkeeperAppContract.vue';
import makeToast from 'Mixins/makeToast';

export default {
  name: 'SolicitateAppModal',
  mixins: [makeToast],
  emits: ['success', 'error'],
  data() {
    return {
      dadosUsuario: [],
      plano_id: null,
      isDemo: false,
      fields: {
        name: '',
        phone: '',
        lojista_id: '',
      },
    };
  },
  methods: {
    open({ shopkeeperId, info, isDemo = false }) {
      this.dadosUsuario = info;
      this.$bvModal.show('modalDados');
      this.fields = {};
      this.fields.lojista_id = shopkeeperId || '';
      this.isDemo = isDemo;
    },
    close() {
      this.$bvModal.hide('modalDados');
    },
    verifyData() {
      if (!this.fields.name) {
        this.makeToast(
          'Erro!',
          'Favor inserir o nome do solicitante!',
          'danger'
        );
        return false;
      }

      if (!this.fields.phone) {
        this.makeToast(
          'Erro',
          'Favor inserir o telefone do solicitante!',
          'danger'
        );
        return false;
      }

      const { phone } = this.fields;
      this.fields.phone = phone.replace(/[^0-9]+/g, '');

      if (this.fields.phone.length < 10) {
        this.makeToast(
          'Erro',
          'Favor preencher corretamento o número de telefone!',
          'danger'
        );
        return false;
      }

      if(this.isDemo){
        this.send();
        return true;
      } 

      this.$bvModal.show('shopkeeper-app-contract');
      return true;
    },
    async send() {
      const { phone } = this.fields;

      var plano_id = 1;
      if(this.$route.query.plano && this.$route.query.plano != '') {
        plano_id = this.$route.query.plano;
      }
      
      const data = {
        lojista_id: this.dadosUsuario.informacoes.id,
        status: 1,
        phone: phone.replace(/[^0-9]+/g,''),
        assinatura: !this.isDemo,
        usuario_id: this.dadosUsuario.id,
        plano_id: this.isDemo ? null : plano_id,
        nome: this.dadosUsuario.nome_usuario,
        email: this.dadosUsuario.email,
        cpf_cnpj: this.dadosUsuario.cnpj,
        street: !this.isDemo ? this.dadosUsuario.informacoes.endereco : "",
        district: !this.isDemo ? this.dadosUsuario.informacoes.bairro : "",
        number: !this.isDemo ? this.dadosUsuario.informacoes.numero : "",
        zip_code: !this.isDemo ? this.dadosUsuario.informacoes.cep : "",
        complement: !this.isDemo ? this.dadosUsuario.informacoes.complemento : "",
        city: !this.isDemo ? this.dadosUsuario.informacoes.cidade.nome : "",
        state: !this.isDemo ? this.dadosUsuario.informacoes.estado.uf : "",
        appDemo: !!this.isDemo,
      }

      this.$store.dispatch('startLoader');
      const result = await this.$store
        .dispatch('lojistaSolicitaApp', data)
        .then(() => {
          this.$store.dispatch('endLoader');
          
          if(this.isDemo){
            this.$emit('success');
            return true;
          } 

          this.$bvModal.hide('shopkeeper-app-contract');
          this.$bvModal.hide('modalDados');

          this.makeToast('Opa!', 'App solicitado com sucesso');

          this.$emit('success');

          return true;
        })
        .catch(() => {
          this.$store.dispatch('endLoader');

          this.$emit('error');

          this.makeToast(
            'Opa!',
            'Infelizmente ocorreu um erro, favor tentar novamente!',
            'danger'
          );

          return false;
        });

      return result;
    },
  },
  components: {
    ShopkeeperAppContract,
  },
};
</script>